import React, {
  useEffect,
  useLayoutEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import Profile from "./Profile/Profile.js";
import ProfileMenu from "./ProfileMenu.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Breadcrumb from "../../Reusable/Breadcrumb/Breadcrumb.js";
import JumboEmbed from "./JumboEmbed/JumboEmbed.js";
import config from "config";
import list from "./listJSON.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import JumboPay from "./JumboPay/JumboPay.js";
import Cookies from "universal-cookie";
import Login from "../../Structure/Login/Login.js";
import Branding from "./Branding/Branding.js";
import NotLoginContainer from "../../Reusable/NotLoginContainer/NotLoginContainer.js";
import Contacts from "./Contacts/Contacts.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import HeaderToast from "./HeaderToast.js";
import Image from "components/Elements/Image/Image.tsx";
import usePageInit from "../../../hooks/usePageInit.ts";
import { useUser } from "contexts/userContext/userContext.js";
import { useParams } from "react-router-dom";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { setLocalStorage, getLocalStorage } from "utils/globalLocalStorage.js";

import "./ProfileUser.scss";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";

const ProfileUser = () => {
  const [isClicked, setIsClicked] = useState(false);
  const { getUserData, isLoggedIn, getUserBillingDetails } = useUser();
  const [notExistEmbedPage, setNotExistEmbedPage] = useState(false);
  const [typeOfDisplayToast, setTypeOfDisplayToast] = useState("");
  const { newMobileCondition } = useMediaQueries();
  const userData = getUserData();
  const userBillingDetails = getUserBillingDetails();
  const isAutoRenewable = userBillingDetails?.auto_renew;
  const params = useParams();
  const { setModal } = useModal();
  const { getTextByKey, getPath, getPageText, getMetaData } = useContent();
  const [activeForDevelopersPage, setActiveForDevelopersPage] = useState({
    pageTitle: getTextByKey("api-title"),
    browserTitle: "api",
  });
  const cookies = new Cookies();
  const isTokenExist = cookies.get(config.api.jumbomailApiAuthCookie);

  const { isPageReady } = usePageInit();

  //if user not loggin - open login modal and if login - return back the page if not - go to home page
  useLayoutEffect(() => {
    if (!isTokenExist) {
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
    }
  }, [isTokenExist]);

  const getEmbedPageByUserId = async () => {
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedDynamicPageByUserId"
    );
    if (response.status === "success") {
      if (response.data && response.data.EmbedPageUserName) {
        setNotExistEmbedPage(false);
      } else {
        setNotExistEmbedPage(true);
      }
    } else {
      setNotExistEmbedPage(true);
    }
  };

  useEffect(() => {
    if (params.profilePage !== undefined && !checkCurrDomainIsOrgDomain()) {
      if (getPageText()) {
        if (getPageText().Browser_title !== undefined) {
          document.title = getPageText().Browser_title;
        }
      }
      if (getMetaData()) {
        if (getMetaData().Meta_Description !== undefined) {
          //set the meta description of the page
          document.description = getMetaData().Meta_Description;
        }
      }
    }
    if (params.profilePage === "api") {
      setActiveForDevelopersPage({
        pageTitle: getTextByKey("api-title"),
        browserTitle: "api",
      });
    }
    if (params.profilePage === "ftp") {
      setActiveForDevelopersPage({
        pageTitle: getTextByKey("ftp-title"),
        browserTitle: "ftp",
      });
    }
    if (params.profilePage === "integration") {
      setActiveForDevelopersPage({
        pageTitle: getTextByKey("integration-title"),
        browserTitle: "integration",
      });
    }
  }, [getPageText(), params.profilePage]);

  const renderPage = () => {
    switch (params.profileCategory) {
      case "":
      case "profile":
      case undefined:
        return <Profile />;
      case "branding":
        return <Branding />;
      case "jumbopay":
        return <JumboPay />;
      case "contacts":
        return <Contacts />;
      case "jumbo-forms":
        return (
          <JumboEmbed
            setActiveForDevelopersPage={setActiveForDevelopersPage}
            activeForDevelopersPage={activeForDevelopersPage}
          />
        );
      default:
        window.location.href = config.baseurl + getPath() + "error";
        break;
    }
  };

  const returnPageName = () => {
    return list.filter((item) => item.category === params.profileCategory)
      .length > 0
      ? list
          .filter((item) => item.category === params.profileCategory)[0]
          .content.filter(
            (page) => page.name.toLowerCase() === params.profilePage
          ).length > 0
        ? list
            .filter((item) => item.category === params.profileCategory)[0]
            .content.filter(
              (page) => page.name.toLowerCase() === params.profilePage
            )[0].text
        : ""
      : "";
  };

  const closeToast = () => {
    const today = new Date().toLocaleDateString();
    //save in local storage
    setLocalStorage("closeToast", today);
    setTypeOfDisplayToast("");
  };

  useMemo(() => {
    if (userData && userData.UserId !== undefined) {
      if (!userData.IsConfirm) {
        window.location.href =
          config.baseurl + getPath() + "registration-complete/incomplete";
      }

      getEmbedPageByUserId(userData.UserId);
    }
  }, [userData]);

  useEffect(() => {
    //get local storage
    const closeToast = getLocalStorage("closeToast");
    const today = new Date().toLocaleDateString();
    if (newMobileCondition) {
      if (closeToast && closeToast === today) {
        setTypeOfDisplayToast("");
      }
    }
  }, []);

  //check if need to display header toast or not
  useEffect(() => {
    if (userData) {
      if (!userData.IsSubscribed) {
        if (userData.SubscribationExpirationDate) {
          const today = new Date();
          const subscriptionExpirationDate = new Date(
            userData.SubscribationExpirationDate
          );
          if (today > subscriptionExpirationDate) {
            //check if different is less than 14 days
            const diffTime = Math.abs(today - subscriptionExpirationDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays <= 14) {
              setTypeOfDisplayToast("expired");
            }
          }
        }
      } else {
        setTypeOfDisplayToast("");
        if (userData.SubscribationExpirationDate) {
          const today = new Date();
          const subscriptionExpirationDate = new Date(
            userData.SubscribationExpirationDate
          );
          if (today <= subscriptionExpirationDate) {
            //check if the different is less than 30 days and not renewable
            const diffTime = Math.abs(subscriptionExpirationDate - today);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays <= 30 && !isAutoRenewable) {
              if (!userData.IsSubUser) {
                setTypeOfDisplayToast("aboutToExpired");
              }
            }
          }
        }
      }
    }
  }, [userData, isAutoRenewable, userData.IsSubscribed]);

  useEffect(() => {
    if (!isLoggedIn()) {
      setTypeOfDisplayToast("");
    }
  }, [isLoggedIn()]);

  if ((isTokenExist && !isLoggedIn()) || !isPageReady) {
    return (
      <div className="profile-page-loader">
        <Image name="preloader" ext="gif" />
      </div>
    );
  }

  return (
    <>
      {isLoggedIn() ? (
        <div
          className={`ProfileUser-container${
            isClicked ? " container-non-active" : ""
          }`}
        >
          {/* <div className="left-spacing"></div> */}

          <div
            className={`ProfileMenu ${
              isClicked ? " menu-active" : " menu-non-active"
            }`}
          >
            <div
              className="close-menu-icon"
              onClick={() => setIsClicked((prev) => !prev)}
            >
              <Icon name="x" />
            </div>
            <ProfileMenu />
          </div>

          <div
            className="mobile-profile-menu"
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            <Icon
              name="home"
              iconClass="header-hamburger-button"
              onClick={(e) => {
                e.stopPropagation();
                setIsClicked((prev) => !prev);
              }}
            />
            <Breadcrumb>
              {params.profileCategory ? (
                <span>
                  {getTextByKey(
                    list.filter(
                      (item) => item.category === params.profileCategory
                    ).length > 0
                      ? list.filter(
                          (item) => item.category === params.profileCategory
                        )[0].title
                      : ""
                  )}
                </span>
              ) : null}
              {params.profilePage ? (
                params.profilePage !== "api" &&
                params.profilePage !== "ftp" &&
                params.profilePage !== "integration" ? (
                  <span>{getTextByKey(returnPageName())}</span>
                ) : (
                  <span>{activeForDevelopersPage.pageTitle}</span>
                )
              ) : null}
            </Breadcrumb>
          </div>
          <div className="userPages">
            {/* {displayHeaderToast && checkHeaderToast()} */}
            {!!typeOfDisplayToast && (
              <HeaderToast
                typeOfDisplayToast={typeOfDisplayToast}
                notExistEmbedPage={notExistEmbedPage}
                closeToast={closeToast}
              />
            )}
            {renderPage()}
            {isClicked && <div className="dark-background-profile-user"></div>}
          </div>
        </div>
      ) : (
        <NotLoginContainer
          TitleKey={"profile-user-pages-not-login-title"}
          TextKey={"profile-user-pages-not-login-text"}
        />
      )}
    </>
  );
};

export default ProfileUser;
